// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2pe8f","overflowing":"ReadFullNote_overflowing__2UAdZ"};